// extracted by mini-css-extract-plugin
module.exports =  {"FilledRanking":"FilledRanking__-Ppjw","filled":"filled__YAAUY","rankingValue":"rankingValue__v27Ic"};